module.exports = __webpack_public_path__ + "media/images/step-one-selected-3178924c.svg";